import { FilterMenuState } from '../Schema/FilterMenuState';
import { createStore } from 'satcheljs';

const initialStore: FilterMenuState = {
    isExtensionFilterExpanded: false,
};

export const getFilterMenuStore = createStore<FilterMenuState>(
    'FilesViewFilterMenuState',
    initialStore
);
